<template>
  <div class="mobile-header">
    <div :class="textColor" class="mobile-header-text text-size-16 w-100">
      <slot> {{ text }} </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RendererMobileHeader',
  props: ['text', 'textColor'],
};
</script>

<style scoped lang="scss">
@import '@/styles/style.scss';

.k-header {
  display: flex;
  flex-direction: row;

  font-size: 1.1rem;
  align-items: center;
  color: #1d1d1d;
  justify-content: center;
}

body.light-mode .mobile-header {
  //background-color: white;
}

body.dark-mode .mobile-header {
  //background-color: $dark-grey;
}

.mobile-header-text {
  height: 57px;
  justify-content: start;
  display: flex;
  align-items: center;
}
</style>